import Vue from 'vue'
import Router from 'vue-router';
import store from '../store';
import {getMenuByListID} from "@/services/role";
import {EventBus} from '../utils/event-bus'

Vue.use(Router)

const router= new Router({
  routes: [
    {
      path: '/redirect',
      hidden: true,
      component: resolve => require(['@/pages/index'], resolve),
      children: [
        {
          path: '/redirect/:path*',
          component: () => import('@/pages/redirect/index')
        }
      ]
    },
    {
      path: '/dashboard/analysis',
      name: 'analysis',
      title: "换电大屏",
      component: resolve => require(['@/pages/dashboard/analysis/index'], resolve),
      meta: { requireAuth: true },
    },
    {
      path: '/dashboard/analysis2',
      name: 'analysis2',
      title: "租赁大屏",
      component: resolve => require(['@/pages/dashboard/analysis2/index'], resolve),
      meta: { requireAuth: true},
    },
    {
      path: '/dashboard/lvwoAnalysis',
      name: 'lvwoAnalysis',
      title: "绿沃大屏",
      component: resolve => require(['@/pages/dashboard/lvwoAnalysis/index'], resolve),
      meta: { requireAuth: true },
    },
// ftLargeDigitalScreen
{
  path: '/ft/bigData',
  name: 'FtLargeDigitalScreen',
  title: "丰田大屏",
  component: resolve => require(['@/pages/ft/ftLargeDigitalScreen/index'], resolve),
  meta: { requireAuth: true },
},
    {
      path: '/dashboard/greenBeauty',
      name: 'greenBeauty',
      title: "格林美大屏",
      component: resolve => require(['@/pages/dashboard/greenBeauty/index'], resolve),
      meta: { requireAuth: true},
    },
    {
      path: '/test/index',
      name: 'analysis',
      title: "大屏数据",
      component: resolve => require(['@/pages/test/index'], resolve),
      meta: { requireAuth: true},
    },
    {
      path: '/dashboard/bigdata',
      name: 'analysis',
      title: "大数据",
      component: resolve => require(['@/pages/dashboard/bigdata/index'], resolve),
      meta: { requireAuth: true},
    },
    {
      path: '/dashboard/hadnleMixData',
      name: 'hadnleMixData',
      title: "菲尼基大屏",
      component: resolve => require(['@/pages/dashboard/hadnleMixData/index'], resolve),
      meta: { requireAuth: true},
    },
    {
      path: '/dashboard/pay',
      name: 'pay',
      title: "支付大屏",
      component: resolve => require(['@/pages/dashboard/pay/index'], resolve),
      meta: { requireAuth: true},
    },
    // {
    //   path: '/',
    //   name: 'login',
    //   title: "登录页",
    //   component: resolve => require(['@/pages/login'], resolve)
    // },
    {
      path: '/',
      name: 'loginFT',
      title: "丰田登录页",
      component: resolve => require(['@/pages/loginFT'], resolve)
    },
    {
      path: '/tokenLogin',
      component:  resolve => require(['@/pages/tokenLogin'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode',
      component:  resolve => require(['@/pages/tools/qrcode/index'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode2',
      component:  resolve => require(['@/pages/tools/qrcode/index2'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode3',
      component:  resolve => require(['@/pages/tools/qrcode/index3'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/auth',
      component:  resolve => require(['@/pages/Auth'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    // {
    //   path: "/bms",
    //   name: "bms",
    //   title: "空页面",
    //   component: resolve => require(['@/pages/bms/index'], resolve),
    //   meta: { requireAuth: false,   title: "空页面" },
    //   children: [
    //     {
    //       path: "/bms/base",
    //       name: "empty",
    //       title: "空页面",
    //       component: resolve => require(['@/pages/bms/base/index'], resolve),
    //       meta: { requireAuth: false,   title: "空页面", }
    //     },

    //     {
    //       path: "/bms/set",
    //       name: "empty",
    //       title: "参数设置",
    //       component: resolve => require(['@/pages/bms/set/index'], resolve),
    //       meta: { requireAuth: false,   title: "空页面", }
    //     }
    //     ]
    // },

    {
      path: '/index',
      name: '',
      title: "侧边栏",
      component: resolve => require(['@/pages/index'], resolve),
      meta: { requireAuth: true, title: "侧边栏", },
      children: [
        {
          path: "/empty",
          name: "empty",
          title: "空页面",
          component: resolve => require(['@/pages/empty/index'], resolve),
          meta: { requireAuth: true,   title: "空页面", }
        },
        {
          path: "/spacepage",
          name: "spacepage",
          title: "空页面",
          component: resolve => require(['@/pages/spacepage/index'], resolve),
          meta: { requireAuth: true,   title: "空页面", }
        },
        {
          path: "/dataStatisticsHomePage",
          name: "HomePage",
          title: "首 页",
          component: resolve => require(['@/pages/dataStatisticsHomePage'], resolve),
          meta: { requireAuth: true,   title: "首 页", }
        },
        // {
        //   path: "/dataStatisticsHomePage22",
        //   name: "HomePage22",
        //   title: "首 页2",
        //   component: resolve => require(['@/pages/dataStatisticsHomePage22'], resolve),
        //   meta: { requireAuth: true,   title: "首 页2", }
        // },
        {
          path: "/operationOverview",
          name: "homePage",
          title: "租赁运营概况",
          component: resolve => require(['@/pages/homePage'], resolve),
          meta: { requireAuth: true,   title: "租赁运营概况", }
        },
        {
          path: '/battery/index',
          name: 'Battery',
          title: "电池列表",
          component: resolve => require(['@/pages/assets/battery/index'], resolve),
          meta: { requireAuth: true,title: "电池列表"}
        },
        {
          path: '/assets/battery/distribution/index',
          name: 'distribution',
          title: "电池分布",
          component: resolve => require(['@/pages/assets/distribution/index'], resolve),
          meta: { requireAuth: true,    title: "电池分布",}
        },
        // {
        //   path: '/assets/distribution1111/index',
        //   name: 'distribution1111',
        //   title: "换电柜展示",
        //   component: resolve => require(['@/pages/assets/distribution1111/index'], resolve),
        //   meta: { requireAuth: true,    title: "换电柜展示",}
        // },
        {
          path: '/index',
          name: 'dataDistribution',
          title: "资产地图",
          component: resolve => require(['@/pages/assets/dataDistribution/index'], resolve),
          meta: { requireAuth: true,    title: "资产地图",}
        },
        {
          path: '/assets/batteryWatch/index',
          name: 'BatteryWatch',
          title: "电池监控",
          component: resolve => require(['@/pages/assets/batteryWatch/index'], resolve),
          meta: { requireAuth: true,    title: "电池监控",}
        }, {
          path: '/assets/getTrack',
          name: 'GetTrack',
          title: "获取轨迹",
          component: resolve => require(['@/pages/assets/getTrack/index'], resolve),
          meta: { requireAuth: true,  title: "获取轨迹", }
        }, {
          path: '/assets/location',
          name: 'Location',
          title: "基站定位",
          component: resolve => require(['@/pages/assets/location'], resolve),
          meta: { requireAuth: true,  title: "基站定位", }
        },
        {
          path: '/assets/chargeCabinet/index',
          name: 'ChargeCabinet',
          title: "换电柜列表",
          component: resolve => require(['@/pages/assets/chargeCabinet/index'], resolve),
          meta: { requireAuth: true,title: "换电柜列表"}
        },
        {
          path: '/assets/chargeCabinet/monitor/index',
          name: 'ChargeCabinetMonitor',
          title: "实时监控",
          component: resolve => require(['@/pages/assets/chargeCabinet/monitor/index'], resolve),
          meta: { requireAuth: true,title: "实时监控"}
        },
        {
          path: '/assets/terminalManagement/index',
          name: 'terminalManagement',
          title: "设备终端",
          component: resolve => require(['@/pages/assets/terminalManagement/index'], resolve),
          meta: { requireAuth: true,title: "设备终端"}
        },
        {
          path: '/assets/sharingVehicleMap/index',
          name: 'sharingVehicleMap',
          title: "共享车辆地图",
          component: resolve => require(['@/pages/assets/sharingVehicleMap/index'], resolve),
          meta: { requireAuth: true,title: "共享车辆地图"}
        },
        {
          path: '/assets/sharingVehicleTrack',
          name: 'sharingVehicleTrack',
          title: "获取共享车辆轨迹",
          component: resolve => require(['@/pages/assets/sharingVehicleTrack/index'], resolve),
          meta: { requireAuth: true,title: "获取共享车辆轨迹"}
        },
        {
          path: '/assets/chargeCabinet/mapLocation',
          name: 'MapLocation',
          title: "地图位置",
          component: resolve => require(['@/pages/assets/chargeCabinet/mapLocation'], resolve),
          meta: { requireAuth: true,title: "地图位置"}
        }
        , {
          path: '/assets/batterycategory/index',
          name: 'Batterycategory',
          title: "电池品牌型号管理",
          component: resolve => require(['@/pages/assets/batterycategory/index'], resolve),
          meta: { requireAuth: true,      title: "电池品牌型号管理",}
        },{
          path: '/assets/chargeCabinetList/index',
          name: 'ChargecabinetList',
          title: "换电柜厂家型号管理",
          component: resolve => require(['@/pages/assets/chargeCabinetList/index'], resolve),
          meta: { requireAuth: true,      title: "换电柜厂家型号管理",}
        },{
          path: '/assets/carManager/index',
          name: 'CarManager',
          title: "车辆品牌型号管理",
          component: resolve => require(['@/pages/assets/carManager/index'], resolve),
          meta: { requireAuth: true,      title: "车辆品牌型号管理",}
        }, {
          path: '/assets/inventory/batteryList/index',
          name: 'BatteryList',
          title: "电池",
          component: resolve => require(['@/pages/assets/inventory/batteryList/index'], resolve),
          meta: { requireAuth: true, title: "电池", }
        },
        {
          path: '/assets/inventory/storeManagement/index',
          name: 'storeManagement',
          title: "仓库管理",
          component: resolve => require(['@/pages/assets/inventory/storeManagement/index'], resolve),
          meta: { requireAuth: true, title: "仓库管理", }
        },
        {
          path: '/assets/inventory/chargeBox/index',
          name: 'ChargeBox',
          title: "换电柜",
          component: resolve => require(['@/pages/assets/inventory/chargeBox/index'], resolve),
          meta: { requireAuth: true, title: "换电柜", }
        },
        {
          path: '/assets/inventory/cars/index',
          name: 'Cars',
          title: "车辆",
          component: resolve => require(['@/pages/assets/inventory/cars/index'], resolve),
          meta: { requireAuth: true, title: "车辆", }
        },
        {
          path: '/operation/ClientManagement/clientPage',
          name: 'clientPage',
          title: "注册客户",
          component: resolve => require(['@/pages/operation/ClientManagement/clientPage'], resolve),
          meta: { requireAuth: true, title: "注册客户", }
        },
        {
          path: '/operation/config/index',
          name: 'operationConfig',
          title: "运营商个性配置",
          component: resolve => require(['@/pages/operation/config/index'], resolve),
          meta: { requireAuth: true, title: "运营商个性配置", }
        },
        {
          path: '/operation/realNameCheck/index',
          name: 'realNameCheck',
          title: "实名认证记录",
          component: resolve => require(['@/pages/operation/realNameCheck/index'], resolve),
          meta: { requireAuth: true, title: "实名认证记录", }
        },
        {
          path: '/Customer/memberCustomers/index',
          name: 'MemberCustomers',
          title: "会员客户",
          component: resolve => require(['@/pages/Customer/memberCustomers/index'], resolve),
          meta: { requireAuth: true, title: "会员客户", }
        },
        {
          path: '/Customer/pupuMember/index',
          name: 'pupuMember',
          title: "朴朴会员",
          component: resolve => require(['@/pages/Customer/pupuMember/index'], resolve),
          meta: { requireAuth: true, title: "朴朴会员", }
        },
        // {
        //   path: '/Customer/idleMember/index',
        //   name: 'idleMember',
        //   title: "闲置会员客户",
        //   component: resolve => require(['@/pages/Customer/idleMember/index'], resolve),
        //   meta: { requireAuth: true, title: "闲置会员客户", }
        // },
        {
          path: '/Customer/blacklistList/index',
          name: 'BlacklistList',
          title: "黑名单",
          component: resolve => require(['@/pages/Customer/blacklistList/index'], resolve),
          meta: { requireAuth: true, title: "黑名单", }
        },
        // enterpriseUsers
        {
          path: '/Customer/enterpriseUsers/index',
          name: 'EnterpriseUsers',
          title: "企业客户",
          component: resolve => require(['@/pages/Customer/enterpriseUsers/index'], resolve),
          meta: { requireAuth: true, title: "企业客户", }
        },
        {
          path: '/Customer/enterpriseUsers/accountDetails',
          name: 'AccountDetails',
          title: "企业账户详情",
          component: resolve => require(['@/pages/Customer/enterpriseUsers/accountDetails'], resolve),
          meta: { requireAuth: true, title: "企业账户详情", }
        },
        // consumptionDetails
        {
          path: '/Customer/enterpriseUsers/consumptionDetails',
          name: 'ConsumptionDetails',
          title: "企业消费明细",
          component: resolve => require(['@/pages/Customer/enterpriseUsers/consumptionDetails'], resolve),
          meta: { requireAuth: true, title: "企业消费明细", }
        },
        {
          path: '/Customer/disabledApply/index',
          name: 'DisabledApply',
          title: "会员禁用审核",
          component: resolve => require(['@/pages/Customer/disabledApply/index'], resolve),
          meta: { requireAuth: true, title: "会员禁用审核", }
        },

        // {
        //   path: '/Customer/enterpriseCustomer/index',
        //   name: 'EnterpriseCustomer',
        //   title: "企业客户",
        //   component: resolve => require(['@/pages/Customer/enterpriseCustomer/index'], resolve),
        //   meta: { requireAuth: true, title: "企业客户", }
        // },{
        //   path: '/Customer/enterpriseCustomer/enterList',
        //   name: 'EnterpriseList',
        //   title: "企业客户详情",
        //   component: resolve => require(['@/pages/Customer/enterpriseCustomer/enterList'], resolve),
        //   meta: { requireAuth: true, title: "企业客户详情", }
        // },
        {
          path: '/operation/ClientManagement/clientList',
          name: 'clientList',
          title: "客户详情",
          component: resolve => require(['@/pages/operation/ClientManagement/clientList'], resolve),
          meta: { requireAuth: true, title: "客户详情", }
        },
        {
          path: '/operation/order/exchange/index',
          name: 'ExchangeOrder',
          title: "换电订单",
          component: resolve => require(['@/pages/operation/order/exchange/index'], resolve),
          meta: { requireAuth: true, title: "换电订单", }
        },
        {
          path: '/operation/Order/exchange/orderList',
          name: 'OrderList',
          title: "换电订单详情",
          component: resolve => require(['@/pages/operation/order/exchange/orderList'], resolve),
          meta: { requireAuth: true, title: "换电订单详情", }
        },
        {
          path: '/operation/order/exchangeHistory/index',
          name: 'ExchangeHistory',
          title: "换电记录",
          component: resolve => require(['@/pages/operation/order/exchangeHistory/index'], resolve),
          meta: { requireAuth: true, title: "换电记录", }
        },
        {
          path: '/operation/order/lease/index',
          name: 'LeaseOrder',
          title: "电池租赁订单",
          component: resolve => require(['@/pages/operation/order/lease/index'], resolve),
          meta: { requireAuth: true, title: "电池租赁订单", }
        },
        {
          path: '/operation/order/lease/detail/index',
          name: 'LeaseOrderDetail',
          title: "电池租赁订单详情",
          component: resolve => require(['@/pages/operation/order/lease/detail'], resolve),
          meta: { requireAuth: true, title: "电池租赁订单详情", }
        },
        {
          path: '/operation/order/carsLeaseOrder/index',
          name: 'CarsLeaseOrder',
          title: "车辆租赁订单",
          component: resolve => require(['@/pages/operation/order/carsLeaseOrder/index'], resolve),
          meta: { requireAuth: true, title: "车辆租赁订单", }
        },
        {
          path: '/operation/order/carsLeaseOrder/carsLeaseDetail',
          name: 'carsLeaseDetail',
          title: "车辆租赁订单详情",
          component: resolve => require(['@/pages/operation/order/carsLeaseOrder/carsLeaseDetail'], resolve),
          meta: { requireAuth: true, title: "车辆租赁订单详情", }
        },
        {
          path: '/operation/order/leaseExpired/index',
          name: 'LeaseExpired',
          title: "逾期订单",
          component: resolve => require(['@/pages/operation/order/leaseExpired/index'], resolve),
          meta: { requireAuth: true, title: "逾期订单", }
        },
        {
          path: '/operation/changeOperatorView/index',
          name: 'ChangeOperatorView',
          title: "换电运营概况",
          component: resolve => require(['@/pages/operation/changeOperatorView/index'], resolve),
          meta: { requireAuth: true, title: "换电运营概况", }
        },
        {
          path: '/operation/carOperatorView/index',
          name: 'carOperatorView',
          title: "车辆运营概况",
          component: resolve => require(['@/pages/operation/carOperatorView/index'], resolve),
          meta: { requireAuth: true, title: "车辆运营概况", }
        },
        {
          path: '/operation/order/salesOrder/index',
          name: 'SalesOrder',
          title: "销售订单",
          component: resolve => require(['@/pages/operation/order/salesOrder/index'], resolve),
          meta: { requireAuth: true, title: "销售订单", }
        },
        {
          path: '/operation/order/salesOrder/SaleOrderList',
          name: 'SaleOrderList',
          title: "销售订单详情",
          component: resolve => require(['@/pages/operation/order/salesOrder/SaleOrderList'], resolve),
          meta: { requireAuth: true, title: "销售订单详情", }
        },
        // {
        //   path: '/orderControl/leaseOrder',
        //   name: 'EnterpriseLeaseOrder',
        //   title: "企业租赁订单",
        //   component: resolve => require(['@/pages/orderControl/leaseOrder'], resolve),
        //   meta: { requireAuth: true, title: "企业租赁订单", }
        // },
        // {
        //   path: '/orderControl/leaseOrder/leaseorderList',
        //   name: 'EnterpriseLeaseOrderList',
        //   title: "企业租赁订单详情",
        //   component: resolve => require(['@/pages/orderControl/leaseOrder/leaseorderList'], resolve),
        //   meta: { requireAuth: true, title: "企业租赁订单详情", }
        // },{
        //   path: '/orderControl/changeOrder',
        //   name: 'EnterpriseChangeOrder',
        //   title: "企业换电订单",
        //   component: resolve => require(['@/pages/orderControl/changeOrder'], resolve),
        //   meta: { requireAuth: true, title: "企业换电订单", }
        // },
        {
          path: '/assets/inventory/simCardList',
          name: 'SimCardList',
          title: "SIM卡",
          component: resolve => require(['@/pages/assets/inventory/simCardList/index'], resolve),
          meta: { requireAuth: true, title: "SIM卡", }
        },
        {
          path: '/operation/operationSite',
          name: 'OperationSite',
          title: "站点管理",
          component: resolve => require(['@/pages/operation/operationSite'], resolve),
          meta: { requireAuth: true, title: "站点管理", }
        },{
          path: '/operation/operationSite/redactGroup',
          name: 'redactGroup',
          title:"编辑站点",
          component: resolve => require(['@/pages/operation/operationSite/redactGroup'], resolve),
          meta: { requireAuth: true,  title:"编辑站点",}
        }, {
          path: '/operation/operationSite/LeaseDetail',
          name: 'LeaseDetail',
          title:"站点详情",
          component: resolve => require(['@/pages/operation/operationSite/LeaseDetail'], resolve),
          meta: { requireAuth: true,    title:"站点详情",}
        },{
          path: '/operation/operationSite/AddGroupPoint',
          name: 'AddGroupPoint',
          title: "新增站点",
          component: resolve => require(['@/pages/operation/operationSite/AddGroupPoint'], resolve),
          meta: { requireAuth: true,  title: "新增站点",}
        }, {
          path: '/operation/operationList/index',
          name: 'operator',
          title: "运营商管理",
          component: resolve => require(['@/pages/operation/operationList/index'], resolve),
          meta: { requireAuth: true,  title: "运营商管理",},
        },
        {
          path: '/operation/operationList/AddOperation',
          name: 'AddOperation',
          title: "新增运营商管理",
          component: resolve => require(['@/pages/operation/operationList/AddOperation'], resolve),
          meta: { requireAuth: true, title: "新增运营商管理", }
        },
        {
          path: '/operation/operationList/updata',
          name: 'editOperation',
          title: "修改运营商管理",
          component: resolve => require(['@/pages/operation/operationList/updata'], resolve),
          meta: { requireAuth: true,   title: "修改运营商管理",}
        },
        {
          path: '/operation/operationList/detailPage',
          name: 'detailPage',
          title: "运营商管理详情页",
          component: resolve => require(['@/pages/operation/operationList/detailPage'], resolve),
          meta: { requireAuth: true, title: "运营商管理详情页",}
        },
        {
          path: '/operation/LeasePointGroup/index',
          name: 'LeasePointGroup',
          title: "站点分组",
          component: resolve => require(['@/pages/operation/LeasePointGroup/index'], resolve),
          meta: { requireAuth: true,  title: "站点分组",}
        },
        {
          path: '/operation/brandFranchisee/index',
          name: 'BrandFranchisee',
          title: "品牌运营商管理",
          component: resolve => require(['@/pages/operation/brandFranchisee/index'], resolve),
          meta: { requireAuth: true,  title: "品牌运营商管理",}
        },
        {
          path: '/operation/LeaseTemplate/billingPage',
          name: 'billingPage',
          title: "租赁计费模板",
          component: resolve => require(['@/pages/operation/LeaseTemplate/billingPage'], resolve),
          meta: { requireAuth: true, title: "租赁计费模板", }
        },
        {
          path: '/operation/ChangeBatTemplate/billingPage',
          name: 'billingPage',
          title: "换电计费模板",
          component: resolve => require(['@/pages/operation/ChangeBatTemplate/billingPage'], resolve),
          meta: { requireAuth: true, title: "换电计费模板", }
        },
        {
          path: '/pricingManagement/salesBillingTemplate/index',
          name: 'SalesBillingTemplate',
          title: "销售计费模板",
          component: resolve => require(['@/pages/pricingManagement/salesBillingTemplate/index'], resolve),
          meta: { requireAuth: true, title: "销售计费模板", }
        },
        {
          path: '/pricingManagement/carBillingTemplate/index',
          name: 'CarBillingTemplate',
          title: "车辆计费模板",
          component: resolve => require(['@/pages/pricingManagement/carBillingTemplate/index'], resolve),
          meta: { requireAuth: true, title: "车辆计费模板", }
        },
        {
          path: '/operation/NewsManagement/newsPage',
          name: 'newsPage',
          title: "小程序消息管理",
          component: resolve => require(['@/pages/operation/NewsManagement/newsPage'], resolve),
          meta: { requireAuth: true,  title: "小程序消息管理", }
        },
        {
          path: '/operation/pushHistory/index',
          name: 'pushHistory',
          title: "消息推送记录",
          component: resolve => require(['@/pages/operation/pushHistory/index'], resolve),
          meta: { requireAuth: true,  title: "消息推送记录", }
        },
        {
          path: '/operation/NewsManagement/addnews',
          name: 'addnews',
          title: "新增小程序消息",
          component: resolve => require(['@/pages/operation/NewsManagement/addnews'], resolve),
          meta: { requireAuth: true,  title: "新增小程序消息", }
        },
        {
          path: '/operation/NewsManagement/updatanews',
          name: 'updatanews',
          title: "修改小程序消息",
          component: resolve => require(['@/pages/operation/NewsManagement/updatanews'], resolve),
          meta: { requireAuth: true,  title: "修改小程序消息", }
        },{
          path: '/operation/allocation/index',
          name: 'allocation',
          title: "调拨管理",
          component: resolve => require(['@/pages/operation/allocation/index'], resolve),
          meta: { requireAuth: true,  title: "调拨管理", }
        },{
          path: '/operation/allocation/allocationlIst',
          name: 'AllocationlIst',
          title: "调拨详情",
          component: resolve => require(['@/pages/operation/allocation/allocationlIst'], resolve),
          meta: { requireAuth: true,  title: "调拨详情", }
        },{
          path: '/operation/allocation/added',
          name: 'Added',
          title: "新建调拨",
          component: resolve => require(['@/pages/operation/allocation/added'], resolve),
          meta: { requireAuth: true,  title: "新建调拨", }
        },{
          path: '/operation/allocation/edited',
          name: 'Editted',
          title: "调拨编辑",
          component: resolve => require(['@/pages/operation/allocation/edited'], resolve),
          meta: { requireAuth: true,  title: "调拨编辑", }
        },
        // {
        //   path: '/assets/FrameNumber/index',
        //   name: 'FrameNumber',
        //   title: "车架号管理",
        //   component: resolve => require(['@/pages/assets/FrameNumber/index'], resolve),
        //   meta: { requireAuth: true,  title: "车架号管理", }
        // },
        // /operation/remoteUpgrade/bmsUpgrade/index
        // {
        //   path: '/operation/remoteUpgrade/communicationModule/index',
        //   name: 'CommunicationModule',
        //   title: "通讯模块",
        //   component: resolve => require(['@/pages/operation/remoteUpgrade/communicationModule/index'], resolve),
        //   meta: { requireAuth: true,  title: "通讯模块", }
        // },
        {
          path: '/operation/remoteUpgrade/bmsUpgrade/index',
          name: 'BmsUpgrade',
          title: "BMS",
          component: resolve => require(['@/pages/operation/remoteUpgrade/bmsUpgrade/index'], resolve),
          meta: { requireAuth: true,  title: "BMS", }
        },
        {
          path: '/operation/apiInterface/accountAuthority/index',
          name: 'AccountAuthority',
          title: "账号权限管理",
          component: resolve => require(['@/pages/operation/apiInterface/accountAuthority/index'], resolve),
          meta: { requireAuth: true,  title: "账号权限管理", }
        },
        {
          path: '/marketingActivities/coupon/index',
          name: 'MarketingActivities',
          title: "优惠券",
          component: resolve => require(['@/pages/marketingActivities/coupon/index'], resolve),
          meta: { requireAuth: true,  title: "优惠券", }
        },
        {
          path: '/marketingActivities/couponRecord/index',
          name: 'CouponRecord',
          title: "优惠券发放记录",
          component: resolve => require(['@/pages/marketingActivities/couponRecord/index'], resolve),
          meta: { requireAuth: true,  title: "优惠券发放记录", }
        },
        {
          path: '/marketingActivities/frozenCoupon/index',
          name: 'FrozenCoupon',
          title: "冻结券",
          component: resolve => require(['@/pages/marketingActivities/frozenCoupon/index'], resolve),
          meta: { requireAuth: true,  title: "冻结券", }
        },
        {
          path: '/marketingActivities/userLabel/index',
          name: 'UserLabel',
          title: "用户标签",
          component: resolve => require(['@/pages/marketingActivities/userLabel/index'], resolve),
          meta: { requireAuth: true,  title: "用户标签", }
        },
        {
          // /marketingActivities/userLevel/index
          path: '/marketingActivities/userLevel/index',
          name: 'UserLevel',
          title: "用户等级",
          component: resolve => require(['@/pages/marketingActivities/userLevel/index'], resolve),
          meta: { requireAuth: true,  title: "用户等级", }
        },
        {
          path: '/operation/disableLogging/index',
          name: 'DisableLogging',
          title: "仓门禁用记录",
          component: resolve => require(['@/pages/operation/disableLogging/index'], resolve),
          meta: { requireAuth: true,  title: "仓门禁用记录", }
        },
        {
          path: '/operation/doorOpenRecord/index',
          name: 'doorOpenRecord',
          title: "仓门开仓记录",
          component: resolve => require(['@/pages/operation/doorOpenRecord/index'], resolve),
          meta: { requireAuth: true,  title: "仓门开仓记录", }
        },
        {
          path: '/operation/doorDisablingReason/index',
          name: 'DoorDisablingReason',
          title: "仓门禁用原因",
          component: resolve => require(['@/pages/operation/doorDisablingReason/index'], resolve),
          meta: { requireAuth: true, title: "仓门禁用原因", }
        },
        // {
        //   path: '/operation/businessAccount/index',
        //   name: 'BusinessAccount',
        //   title: "资产使用情况",
        //   component: resolve => require(['@/pages/operation/businessAccount/index'], resolve),
        //   meta: { requireAuth: true,  title: "资产使用情况", }
        // },
        {
          path: '/systemSet/accountAdmin',
          name: 'accountAdmin',
          title: "账号管理",
          component: resolve => require(['@/pages/systemSet/accountAdmin'], resolve),
          meta: { requireAuth: true,  title: "账号管理", }
        }, {
          path: '/systemSet/roleAdmin/index',
          name: 'roleAdmin',
          title: "角色管理",
          component: resolve => require(['@/pages/systemSet/roleAdmin/index'], resolve),
          meta: { requireAuth: true, title: "角色管理", }
        }, {
          path: '/systemSet/DataDictionary',
          name: 'DataDictionary',
          title: "数据字典",
          component: resolve => require(['@/pages/systemSet/DataDictionary'], resolve),
          meta: { requireAuth: true,   title: "数据字典",}
        },
        {
          path: '/systemSet/systemMsg/index',
          name: 'SystemMsg',
          title: "系统消息",
          component: resolve => require(['@/pages/systemSet/systemMsg/index'], resolve),
          meta: { requireAuth: true,   title: "系统消息",}
        },
        {
          path: '/systemSet/systemMsg/addNews',
          name: 'SystemMsg',
          title: "新增系统消息",
          component: resolve => require(['@/pages/systemSet/systemMsg/addNews'], resolve),
          meta: { requireAuth: true,   title: "新增系统消息",}
        },
        {
          path: '/systemSet/systemMsg/editpage',
          name: 'SystemMsg',
          title: "编辑系统消息",
          component: resolve => require(['@/pages/systemSet/systemMsg/editpage'], resolve),
          meta: { requireAuth: true,   title: "编辑系统消息",}
        },
        {
          path: '/monitoring/unusual',
          name: 'unusual',
          title: "电池异常告警(V1.0)",
          component: resolve => require(['@/pages/monitoring/unusual'], resolve),
          meta: { requireAuth: true,    title: "电池异常告警(V1.0)",}
        },
        {
          path: '/monitoring/mpMonitorSet',
          name: 'unusual',
          title: "公众号告警设置",
          component: resolve => require(['@/pages/monitoring/mpMonitorSet'], resolve),
          meta: { requireAuth: true,    title: "公众号告警设置",}
        },
        // unusualFour
        {
          path: '/monitoring/batteryAbnormalAlarm',
          name: 'batteryAbnormalAlarm',
          title: "电池异常告警(V3.0)",
          component: resolve => require(['@/pages/monitoring/batteryAbnormalAlarm'], resolve),
          meta: { requireAuth: true,    title: "电池异常告警(V3.0)",}
        },
        {
          path: '/monitoring/uDanDeviceController',
          name: 'UDanDeviceController',
          title: "电池异常告警",
          component: resolve => require(['@/pages/monitoring/uDanDeviceController'], resolve),
          meta: { requireAuth: true,    title: "电池异常告警",}
        },
        {
          path: '/monitoring/MapLocation',
          name: 'MapLocation',
          title: "异常告警定位详情",
          component: resolve => require(['@/pages/monitoring/MapLocation'], resolve),
          meta: { requireAuth: true,title: "异常告警定位详情", }
        },{
          path: '/monitoring/towerAlarm',
          name: 'TowerAlarm',
          title: "电池异常告警(V2.0)",
          component: resolve => require(['@/pages/monitoring/towerAlarm'], resolve),
          meta: { requireAuth: true,    title: "电池异常告警(V2.0)",}
        },
        {
          path: '/monitoring/alarmRemind',
          name: 'AlarmRemind',
          title: "告警弹窗设置",
          component: resolve => require(['@/pages/monitoring/alarmRemind/index'], resolve),
          meta: { requireAuth: true,    title: "告警弹窗设置",}
        },
        // {
        //   path: '/monitoring/electronicFence',
        //   name: 'ElectronicFence',
        //   title: "电子围栏",
        //   component: resolve => require(['@/pages/monitoring/electronicFence/index'], resolve),
        //   meta: { requireAuth: true,    title: "电子围栏",}
        // },
        // {
        //   path: '/monitoring/electronicFence/add',
        //   name: 'ElectronicFenceAdd',
        //   title: "新增电子围栏",
        //   component: resolve => require(['@/pages/monitoring/electronicFence/add'], resolve),
        //   meta: { requireAuth: true,    title: "新增电子围栏",}
        // },
        // {
        //   path: '/monitoring/electronicFence/edit',
        //   name: 'ElectronicFenceUpdate',
        //   title: "修改电子围栏",
        //   component: resolve => require(['@/pages/monitoring/electronicFence/edit'], resolve),
        //   meta: { requireAuth: true,    title: "修改电子围栏",}
        // },
        {
          // path: '/dashboard/assets',
          path: '/assetsReport/report',
          name: 'reportAsset',
          title: "资产报表",
          // component: resolve => require(['@/pages/dashboard/assets/index'], resolve),
          component: resolve => require(['@/pages/assetsReport/report/index'], resolve),
          meta: { requireAuth: true,    title: "资产报表",}
        },
        {
          // path: '/dashboard/monitoring',
          path: '/afterTheReport/report',
          name: 'reportMonitor',
          title: "监控统计报表",
          // component: resolve => require(['@/pages/dashboard/monitoring/index'], resolve),
          component: resolve => require(['@/pages/afterTheReport/report/index'], resolve),
          meta: { requireAuth: true,    title: "监控统计报表",}
        },
        // operationReport
        // {
        //   path: '/dashboard/operation',
        //   name: 'reportOperation',
        //   title: "运营报表",
        //   component: resolve => require(['@/pages/dashboard/operation/index'], resolve),
        //   meta: { requireAuth: true,    title: "运营报表",}

        // },
        {
          path: '/dashboard/operationReport',
          name: 'OperationReport',
          title: "换电运营报表",
          component: resolve => require(['@/pages/dashboard/operationReport/index'], resolve),
          meta: { requireAuth: true,    title: "换电运营报表",}

        },
        {
          path: '/Finance/Recharge',
          name: 'Recharge',
          title: "资金流水",
          component: resolve => require(['@/pages/Finance/Recharge'], resolve),
          meta: { requireAuth: true,    title: "资金流水",}

        },
        {
          path: '/Finance/withdrawal',
          name: 'Withdrawal',
          title: "提现审核",
          component: resolve => require(['@/pages/Finance/withdrawal'], resolve),
          meta: { requireAuth: true,    title: "提现审核",}
        },
        {
          path: '/Finance/thawApply',
          name: 'thawApply',
          title: "押金解冻审核",
          component: resolve => require(['@/pages/Finance/thawApply'], resolve),
          meta: { requireAuth: true,    title: "押金解冻审核",}
        },
        {
          path: '/Finance/abnormalRentRefund',
          name: 'AbnormalRentRefund',
          title: "异常退租审核",
          component: resolve => require(['@/pages/Finance/abnormalRentRefund'], resolve),
          meta: { requireAuth: true,    title: "异常退租审核",}
        },
        // {
        //   path: '/Finance/receivable/receivablePage',
        //   name: 'ReceivablePage',
        //   title: "应收管理",
        //   component: resolve => require(['@/pages/Finance/receivable/receivablePage'], resolve),
        //   meta: { requireAuth: true,    title: "应收管理",}
        //
        // },
        // /Finance/revenueManagement/index
        {
          path: '/Finance/revenueManagement',
          name: 'RevenueManagement',
          title: "订单收入记录",
          component: resolve => require(['@/pages/Finance/revenueManagement/index'], resolve),
          meta: { requireAuth: true,    title: "订单收入记录",}

        }, {
          path: '/Finance/leaseOrdersRevenue',
          name: 'LeaseOrdersRevenue',
          title: "租赁订单收入记录",
          component: resolve => require(['@/pages/Finance/leaseOrdersRevenue/index'], resolve),
          meta: { requireAuth: true,    title: "租赁订单收入记录",}

        },
        {
          path: '/Finance/revenueManagement2',
          name: 'RevenueManagement2',
          title: "换电订单收入记录",
          component: resolve => require(['@/pages/Finance/revenueManagement2/index'], resolve),
          meta: { requireAuth: true,    title: "换电订单收入记录",}

        },
        {
          path: '/Finance/memberBill/index',
          name: 'ReceivablePage',
          title: "会员账单",
          component: resolve => require(['@/pages/Finance/memberBill/index'], resolve),
          meta: { requireAuth: true,    title: "会员账单",}
        },
        {
          path: '/Finance/rechargeRecord/index',
          name: 'RechargeRecord',
          title: "后台充值记录",
          component: resolve => require(['@/pages/Finance/rechargeRecord/index'], resolve),
          meta: { requireAuth: true,    title: "后台充值记录",}
        },
        // /Finance/rechargeRecord/index
        {
          path: '/Finance/receivable/receivableList',
          name: 'ReceivableList',
          title: "应收详情",
          component: resolve => require(['@/pages/Finance/receivable/receivableList'], resolve),
          meta: { requireAuth: true,    title: "应收详情",}

        },
        {
          path: '/Finance/arrearageOrder',
          name: 'ArrearageOrder',
          title: "欠费订单",
          component: resolve => require(['@/pages/Finance/ArrearageOrder/index'], resolve),
          meta: { requireAuth: true,    title: "欠费订单",}

        },
        {
          path: '/Finance/enterpriseRenewalApproval',
          name: 'EnterpriseRenewalApproval',
          title: "企业客户订单审核",
          component: resolve => require(['@/pages/Finance/enterpriseRenewalApproval/index'], resolve),
          meta: { requireAuth: true,    title: "企业客户订单审核",}
        },
        // /Finance/assetDepreciationRules
        {
          path: '/Finance/assetDepreciationRules',
          name: 'AssetDepreciationRules',
          title: "资产折旧规则",
          component: resolve => require(['@/pages/Finance/assetDepreciationRules/index'], resolve),
          meta: { requireAuth: true,    title: "资产折旧规则",}
        },
        {
          path: '/Finance/assetDepreciationList',
          name: 'AssetDepreciationList',
          title: "资产折旧明细",
          component: resolve => require(['@/pages/Finance/assetDepreciationList/index'], resolve),
          meta: { requireAuth: true,    title: "资产折旧明细",}
        },
        {
          path: '/afterSale/afterSaleJobs',
          name: 'AfterSaleJobs',
          title: "换电工单",
          component: resolve => require(['@/pages/afterSale/afterSaleJobs/index'], resolve),
          meta: { requireAuth: true,    title: "换电工单",}

        },
        {
          path: '/afterSale/afterSaleJobs/JobsList',
          name: 'JobsList',
          title: "换电工单信息详情",
          component: resolve => require(['@/pages/afterSale/afterSaleJobs/JobsList'], resolve),
          meta: { requireAuth: true,    title: "换电工单信息详情",}

        },
        {
          path: '/afterSale/afterSalePeople',
          name: 'AfterSalePeople',
          title: "售后人员",
          component: resolve => require(['@/pages/afterSale/afterSalePeople/index'], resolve),
          meta: { requireAuth: true,    title: "售后人员",}

        },
        {
          path: '/afterSale/faultContent',
          name: 'FaultContent',
          title: "换电故障定义",
          component: resolve => require(['@/pages/afterSale/faultContent/index'], resolve),
          meta: { requireAuth: true,    title: "换电故障定义",}
        },
        // {
        //   path: '/afterSale/clockRecord',
        //   name: 'ClockRecord',
        //   title: "售后打卡记录",
        //   component: resolve => require(['@/pages/afterSale/clockRecord/index'], resolve),
        //   meta: { requireAuth: true,    title: "售后打卡记录",}
        // },
        {
          path: '/afterSale/faultRecord',
          name: 'FaultRecord',
          title: "租赁工单",
          component: resolve => require(['@/pages/afterSale/faultRecord/index'], resolve),
          meta: { requireAuth: true,    title: "租赁工单",}
        },
        // /afterSale/bmstTreshold
        {
          path: '/afterSale/bmstTreshold',
          name: 'BmstTreshold',
          title: "BMS保护阈值",
          component: resolve => require(['@/pages/afterSale/bmstTreshold/index'], resolve),
          meta: { requireAuth: true,    title: "BMS保护阈值",}
        },
        {
          path: '/systemSet/accountLevel/index',
          name: 'AccountLevel',
          title: "账号等级",
          component: resolve => require(['@/pages/systemSet/accountLevel/index'], resolve),
          meta: { requireAuth: true,   title: "账号等级",}
        },
        {
          path: '/productionManagement/personnelManagement',
          name: 'personnelManagement',
          title: "生产人员管理",
          component: resolve => require(['@/pages/productionManagement/personnelManagement'], resolve),
          meta: { requireAuth: true,   title: "生产人员管理",}
        },
        {
          path: '/productionManagement/taskManagement/index',
          name: 'taskManagement',
          title: "生产任务管理",
          component: resolve => require(['@/pages/productionManagement/taskManagement/index'], resolve),
          meta: { requireAuth: true,   title: "生产任务管理",}
        },
        {
          path: '/productionManagement/deviceCheck/index',
          name: 'deviceCheck',
          title: "电池检测标准",
          component: resolve => require(['@/pages/productionManagement/deviceCheck/index'], resolve),
          meta: { requireAuth: true,   title: "电池检测标准",}
        },
        // {
        //   path: '/operation/operatorAudit/index',
        //   name: 'operatorAudit',
        //   title: "运营商审核",
        //   component: resolve => require(['@/pages/operation/operatorAudit/index'], resolve),
        //   meta: { requireAuth: true,   title: "运营商审核",}
        // },
        //  {
        //   path: '/operation/operatorAudit/operationDetail',
        //   name: 'operationDetail',
        //   title:"运营商审核详情页",
        //   component: resolve => require(['@/pages/operation/operatorAudit/operationDetail'], resolve),
        //   meta: { requireAuth: true,    title:"运营商审核详情页",}
        //   },

        {
          path: '/operation/salesmanManagement/index',
          name: 'Salesman',
          title: "业务员管理",
          component: resolve => require(['@/pages/operation/salesmanManagement/index'], resolve),
          meta: { requireAuth: true,   title: "业务员管理",}
        },
        {
          path: '/operation/proxy/index',
          name: 'proxy',
          title: "代理商管理",
          component: resolve => require(['@/pages/operation/proxy/index'], resolve),
          meta: { requireAuth: true,   title: "代理商管理",}
        },

        {
          path: '/assetsReportIt/index',
          name: 'assetsReportIt',
          title: "资产报失",
          component: resolve => require(['@/pages/assets/assetsReportIt/index'], resolve),
          meta: { requireAuth: true,    title: "资产报失",}
        },
        {
          path: '/siteProfitSharing/index',
          name: 'siteProfitSharing',
          title: "分账配置",
          component: resolve => require(['@/pages/operation/siteProfitSharing/index'], resolve),
          meta: { requireAuth: true,    title: "分账配置",}
        },
        {
          path: '/operatorProfitSharing/index',
          name: 'operatorProfitSharing',
          title: "运营商分账配置",
          component: resolve => require(['@/pages/operation/operatorProfitSharing/index'], resolve),
          meta: { requireAuth: true,    title: "运营商分账配置",}
        },
        {
          path: '/operation/order/batteryReplacementRecord/index',
          name: 'batteryReplacementRecord',
          title: "电池更换记录",
          component: resolve => require(['@/pages/operation/order/batteryReplacementRecord/index'], resolve),
          meta: { requireAuth: true,    title: "电池更换记录",}
        },
        {
          path: '/monitoring/cabinetAlarm',
          name: 'cabinetAlarm',
          title: "换电柜异常告警",
          component: resolve => require(['@/pages/monitoring/cabinetAlarm'], resolve),
          meta: { requireAuth: true,    title: "换电柜异常告警",}
        },
        {
          path: '/Finance/carsOrderRevenue',
          name: 'CarsOrderRevenue',
          title: "车辆单收入记录",
          component: resolve => require(['@/pages/Finance/carsOrderRevenue/index'], resolve),
          meta: { requireAuth: true,    title: "车辆订单收入记录",}
        },
        {
          path: '/assets/vehicleBrandModel/index',
          name: 'vehicleBrandModel',
          title: "车辆品牌型号管理",
          component: resolve => require(['@/pages/assets/vehicleBrandModel/index'], resolve),
          meta: { requireAuth: true,    title: "车辆品牌型号管理",}
        },
        {
          path: '/assets/vehicleList/index',
          name: 'vehicleList',
          title: "车辆列表",
          component: resolve => require(['@/pages/assets/vehicleList/index'], resolve),
          meta: { requireAuth: true,    title: "车辆列表",}
        },
        {
          path: '/assets/vehicleList/vehicleMonitor/index',
          name: 'VehicleMonitor',
          title: "车辆监控",
          component: resolve => require(['@/pages/assets/vehicleList/vehicleMonitor/index'], resolve),
          meta: { requireAuth: true,title: "车辆监控"}
        },
        // {
        //   path: '/assets/vehicleList/track/index',
        //   name: 'vehicleTrack',
        //   title: "车辆轨迹",
        //   component: resolve => require(['@/pages/assets/vehicleList/VehiclesTrack/index'], resolve),
        //   meta: { requireAuth: true,    title: "车辆轨迹",}
        // },
        {
          path: '/assets/vehicleInOutManagement/index',
          name: 'vehicleInOutManagement',
          title: "车辆出入库管理",
          component: resolve => require(['@/pages/assets/vehicleInOutManagement/index'], resolve),
          meta: { requireAuth: true,    title: "车辆出入库管理",}
        },
        {
          path: '/operation/serviceChargeBill',
          name: 'serviceChargeBill',
          title: "服务费账单",
          component: resolve => require(['@/pages/operation/serviceChargeBill/index'], resolve),
          meta: { requireAuth: true,    title: "服务费账单",}
        },
        {
          path: '/operation/onlineBulletin',
          name: 'onlineBulletin',
          title: "线上公告",
          component: resolve => require(['@/pages/operation/onlineBulletin/index'], resolve),
          meta: { requireAuth: true,    title: "线上公告",}
        },
        // shortMessageNumber
        {
          path: '/operation/shortMessageNumber',
          name: 'ShortMessageNumber',
          title: "短信发送量统计",
          component: resolve => require(['@/pages/operation/shortMessageNumber/index'], resolve),
          meta: { requireAuth: true,    title: "短信发送量统计",}
        },
        {
          path: '/assets/assetDeletionRecord',
          name: 'assetDeletionRecord',
          title: "资产删除记录",
          component: resolve => require(['@/pages/assets/assetDeletionRecord/index'], resolve),
          meta: { requireAuth: true,    title: "资产删除记录",}
        },
        {
          path: '/afterSale/hNdisabilitiesRecord',
          name: 'hNdisabilitiesRecord',
          title: "华诺报障记录",
          component: resolve => require(['@/pages/afterSale/hNdisabilitiesRecord/index'], resolve),
          meta: { requireAuth: true,    title: "华诺报障记录",}
        },
        {
          path: '/afterSale/afterSaleRole',
          name: 'afterSaleRole',
          title: "售后人员角色",
          component: resolve => require(['@/pages/afterSale/afterSaleRole/index'], resolve),
          meta: { requireAuth: true,    title: "售后人员角色",}
        },
        {
          path: '/afterSale/workOrder',
          name: 'workOrder',
          title: "BMS工单",
          component: resolve => require(['@/pages/afterSale/workOrder/index'], resolve),
          meta: { requireAuth: true,    title: "BMS工单",}
        },
        // {
        //   path: '/operation/remoteUpgrade/batterCommandBatch/index',
        //   name: 'batterCommandBatch',
        //   title: "电池命令批量执行",
        //   component: resolve => require(['@/pages/operation/remoteUpgrade/batterCommandBatch/index'], resolve),
        //   meta: { requireAuth: true,    title: "电池命令批量执行",}
        // },
        {
          path: '/exchangeMerchantManagement/merchantManagement',
          name: 'MerchantManagement',
          title: "商家管理",
          component: resolve => require(['@/pages/exchangeMerchantManagement/merchantManagement/index'], resolve),
          meta: { requireAuth: true,    title: "商家管理",}
        },
        {
          path: '/exchangeMerchantManagement/merchantManagement/AddMerchant',
          name: 'AddMerchant',
          title: "商家创建",
          component: resolve => require(['@/pages/exchangeMerchantManagement/merchantManagement/AddMerchant'], resolve),
          meta: { requireAuth: true,    title: "商家创建",}
        },
        {
          path: '/exchangeMerchantManagement/merchantManagement/EditMerchant',
          name: 'EditMerchant',
          title: "商家编辑",
          component: resolve => require(['@/pages/exchangeMerchantManagement/merchantManagement/EditMerchant'], resolve),
          meta: { requireAuth: true,    title: "商家编辑",}
        },
        {
          path: '/exchangeMerchantManagement/merchantManagement/merchantList',
          name: 'MerchantList',
          title: "商家详情页",
          component: resolve => require(['@/pages/exchangeMerchantManagement/merchantManagement/merchantList'], resolve),
          meta: { requireAuth: true,    title: "商家详情页",}
        },
        {
          path: '/exchangeMerchantManagement/siteRentReview',
          name: 'SiteRentReview',
          title: "场租审核",
          component: resolve => require(['@/pages/exchangeMerchantManagement/siteRentReview/index'], resolve),
          meta: { requireAuth: true,    title: "场租审核",}
        },
        {
          path: '/exchangeMerchantManagement/electricityChargeReview',
          name: 'ElectricityChargeReview',
          title: "电费审核",
          component: resolve => require(['@/pages/exchangeMerchantManagement/electricityChargeReview/index'], resolve),
          meta: { requireAuth: true,    title: "电费审核",}
        },
        // /exchangeMerchantManagement/withdrawalList
        {
          path: '/exchangeMerchantManagement/withdrawalList',
          name: 'WithdrawalList',
          title: "提现记录",
          component: resolve => require(['@/pages/exchangeMerchantManagement/withdrawalList/index'], resolve),
          meta: { requireAuth: true,    title: "商家提现记录",}
        },
        {
          path: '/exchangeMerchantManagement/extensionList',
          name: 'ExtensionList',
          title: "推广记录",
          component: resolve => require(['@/pages/exchangeMerchantManagement/extensionList/index'], resolve),
          meta: { requireAuth: true,    title: "商家推广记录",}
        },
        {
          path: '/Finance/deductionRecord',
          name: 'DeductionRecord',
          title: "免押扣款记录",
          component: resolve => require(['@/pages/Finance/deductionRecord'], resolve),
          meta: { requireAuth: true,    title: "免押扣款记录",}
        },
        // electrovalenceManagement
        {
          path: '/operation/electrovalenceManagement',
          name: 'ElectrovalenceManagement',
          title: "电价管理",
          component: resolve => require(['@/pages/operation/electrovalenceManagement'], resolve),
          meta: { requireAuth: true,    title: "电价管理",}
        },
        {
          path: '/operation/bordereaux',
          name: 'bordereaux',
          title: "业务报表",
          component: resolve => require(['@/pages/operation/bordereaux'], resolve),
          meta: { requireAuth: true,    title: "业务报表",}
        },

        
      ]
    }
  ]
})

router.beforeEach(async(to,from,next)=>{

  if (to.meta.requireAuth) {
    if(sessionStorage.getItem("token")){
      const hasPermission =store.getters.permission && store.getters.permission.length>0;
      if(hasPermission){
        next()
      }else{
        const ids=await getMenuByListID();
        // const ids= JSON.parse(sessionStorage.getItem("IDS"));
        if(ids.length==0){
          if(localStorage.getItem("loginPath")=='/ft/login'){
            next({path: '/ft/login'})
           }else{
            next({path: '/'})
           }

          return;
        }
        store.dispatch('permission/setPermission', ids)
      }
      next();

    }else{
      if(localStorage.getItem("loginPath")=='/ft/login'){
        next({path: '/ft/login'})
       }else{
        next({path: '/'})
       }


    }
  }else{
    next();
    // if(to.path!=="/"){
    //   next({ path: '/'});
    //   }else{
    //     next();
    //   }

  }
})
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {

  return originalPush.call(this, location).catch(err => err)

}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js